var _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _path9, _circle2, _circle3, _circle4, _circle5, _circle6, _polygon, _path10, _polygon2, _path11, _polygon3, _path12, _path13, _path14, _circle7, _path15, _polygon4, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 779.13499,
    height: 550.24072,
    viewBox: "0 0 779.13499 550.24072",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M262.71619,725.12036l-.95117-1.75879c12.75342-6.89746,28.62573-15.481,36.916-29.56738,8.17237-13.88623,8.35572-32.74268.47852-49.21094-6.70361-14.01562-19.01782-26.57226-35.61108-36.313-3.273-1.92138-6.70874-3.74218-10.0315-5.50341-8.03149-4.25635-16.33642-8.65821-23.18432-14.90284-9.43165-8.60107-16.56788-23.03466-11.249-35.89111a23.85566,23.85566,0,0,1,20.67749-14.46728l.1128,1.99707a21.8606,21.8606,0,0,0-18.94776,13.248c-4.94263,11.94727,1.83862,25.50489,10.75415,33.63574,6.66065,6.07374,14.85181,10.415,22.7732,14.61329,3.34155,1.771,6.79711,3.60253,10.10766,5.54589,16.93848,9.94336,29.52637,22.79786,36.40259,37.17432,8.1604,17.06055,7.94629,36.63672-.55908,51.08887C291.83191,709.37476,275.68811,718.10571,262.71619,725.12036Z",
    transform: "translate(-210.43251 -174.87964)",
    fill: "#f1f1f1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.00438,
    cy: 364.66713,
    rx: 17.5,
    ry: 8.5,
    fill: "#f1f1f1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.00438,
    cy: 420.66713,
    rx: 17.5,
    ry: 8.5,
    fill: "#f1f1f1"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.00438,
    cy: 429.66713,
    rx: 17.5,
    ry: 8.5,
    fill: "#f1f1f1"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.00438,
    cy: 476.66713,
    rx: 17.5,
    ry: 8.5,
    fill: "#f1f1f1"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.00438,
    cy: 476.66713,
    rx: 17.5,
    ry: 8.5,
    fill: "#f1f1f1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M964.10365,638.87964H679.27037a25.49265,25.49265,0,0,1-25.46385-25.46385V200.34349a25.49264,25.49264,0,0,1,25.46385-25.46385H964.10365a25.49264,25.49264,0,0,1,25.46384,25.46385v413.0723A25.49264,25.49264,0,0,1,964.10365,638.87964Z",
    transform: "translate(-210.43251 -174.87964)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M964.605,622.63314H678.769a7.85848,7.85848,0,0,1-7.84951-7.84951v-415.808a7.85848,7.85848,0,0,1,7.84951-7.84951H964.605a7.85848,7.85848,0,0,1,7.84951,7.84951v415.808A7.85848,7.85848,0,0,1,964.605,622.63314Z",
    transform: "translate(-210.43251 -174.87964)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 610.1714,
    cy: 7.79832,
    r: 2.1662,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M936.89784,464.92937H706.47618a.72116.72116,0,0,1-.72112-.72112V353.76715a.72111.72111,0,0,1,1.44223,0v109.72H936.89784a.72112.72112,0,0,1,0,1.44223Z",
    transform: "translate(-210.43251 -174.87964)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M755.70725,456.99711H734.7495a2.143,2.143,0,0,1-2.14063-2.14046V425.96629a2.143,2.143,0,0,1,2.14063-2.14046h20.95775a2.143,2.143,0,0,1,2.14063,2.14046v28.89036A2.143,2.143,0,0,1,755.70725,456.99711Z",
    transform: "translate(-210.43251 -174.87964)",
    fill: "#00bfa6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M793.92633,456.99711H772.96858a2.143,2.143,0,0,1-2.14063-2.14046V398.56393a2.143,2.143,0,0,1,2.14063-2.14045h20.95775a2.143,2.143,0,0,1,2.14063,2.14045v56.29272A2.143,2.143,0,0,1,793.92633,456.99711Z",
    transform: "translate(-210.43251 -174.87964)",
    fill: "#00bfa6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M832.1454,456.99711H811.18766a2.143,2.143,0,0,1-2.14063-2.14046V425.96629a2.143,2.143,0,0,1,2.14063-2.14046H832.1454a2.143,2.143,0,0,1,2.14064,2.14046v28.89036A2.143,2.143,0,0,1,832.1454,456.99711Z",
    transform: "translate(-210.43251 -174.87964)",
    fill: "#00bfa6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M870.36448,456.99711H849.40673a2.09618,2.09618,0,0,1-2.14063-2.04349V387.65025a2.09617,2.09617,0,0,1,2.14063-2.04349h20.95775a2.09617,2.09617,0,0,1,2.14063,2.04349v67.30337A2.09618,2.09618,0,0,1,870.36448,456.99711Z",
    transform: "translate(-210.43251 -174.87964)",
    fill: "#00bfa6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M908.58356,456.99711H887.62581a2.143,2.143,0,0,1-2.14063-2.14046V368.27712a2.143,2.143,0,0,1,2.14063-2.14046h20.95775a2.143,2.143,0,0,1,2.14063,2.14046v86.57953A2.143,2.143,0,0,1,908.58356,456.99711Z",
    transform: "translate(-210.43251 -174.87964)",
    fill: "#00bfa6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 534.79587,
    cy: 235.96613,
    r: 4.32669,
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 573.01495,
    cy: 207.84266,
    r: 4.32669,
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 611.23402,
    cy: 235.96613,
    r: 4.32669,
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 649.4531,
    cy: 194.14148,
    r: 4.32669,
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 687.67218,
    cy: 178.27696,
    r: 4.32669,
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "611.325 236.935 573.015 208.241 535.228 236.543 534.363 235.389 573.015 206.438 611.143 234.997 649.031 193.534 649.184 193.472 687.403 178.073 687.942 179.411 649.875 194.749 611.325 236.935",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M485.06053,399.365a9.97532,9.97532,0,0,0-7.666,3.58362l-44.80957-1.40076-1.7539-7.55432-23.18946,11.31628,3,20.68915,68.29029-8.7439a9.99612,9.99612,0,1,0,6.12866-17.89007Z",
    transform: "translate(-210.43251 -174.87964)",
    fill: "#9f616a"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "191.627 537.085 203.887 537.085 209.72 489.797 191.625 489.798 191.627 537.085",
    fill: "#9f616a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M398.93258,707.96221l24.144-.001h.001a15.3873,15.3873,0,0,1,15.38647,15.38623v.5l-39.53076.00146Z",
    transform: "translate(-210.43251 -174.87964)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "145.367 527.336 157.145 530.74 175.877 486.93 158.494 481.907 145.367 527.336",
    fill: "#9f616a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M353.90611,697.50228l23.19508,6.70245.00094.00027a15.38729,15.38729,0,0,1,10.50969,19.05325l-.13882.48034-37.977-10.974Z",
    transform: "translate(-210.43251 -174.87964)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M387.0043,506.62745s-4.36065,12.16644,2.51849,28.76629l5.30827,68.36757,1.57088,97.23228h22.35039l13.52613-99.12205,8.12348-89.87795Z",
    transform: "translate(-210.43251 -174.87964)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M374.43342,506.62745s-4.36066,12.16644,2.51849,28.76629l5.30826,68.36757L355.83106,696.365h22.35039l41.52613-94.49349,8.12348-89.87795Z",
    transform: "translate(-210.43251 -174.87964)",
    fill: "#2f2e41"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 229.56703,
    cy: 150.37671,
    r: 24.56103,
    fill: "#9f616a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M443.28477,385.00087l-4.97733-23.12665-25.3443-14.38992-5.13925,7.195s-36.26449,9.52971-31.87866,51.172,2.38583,61.64229,2.38583,61.64229l-10,46s3.07821.52876,73.72947,12.87144l3-100Z",
    transform: "translate(-210.43251 -174.87964)",
    fill: "#cbcbcb"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "208.266 435.17 185.251 481.659 185.251 494.985 208.266 435.17",
    opacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M413.51771,333.02513c2.34185,6.27154,11.20293,7.14055,14.32845,1.22045a8.05532,8.05532,0,0,0,.59139-1.439c.85617-2.84351.31764-5.97591,1.8989-8.69474a4.59047,4.59047,0,0,1,1.60475-1.65782c5.25606-3.10017,10.42979,6.7369,15.31761,3.98469,2.9971-1.68758,2.35605-6.58835,5.02308-8.76033,3.52005-2.86665,8.6045,1.40286,13.11791.91535,5.02171-.54242,7.398-6.904,6.30631-11.83552-1.3314-6.0142-6.03657-10.89566-11.55789-13.62665s-11.79477-3.55561-17.95268-3.70867c-6.99662-.17391-14.31787.56876-20.23379,4.30839-7.19438,4.5478-11.24768,13.01406-12.14491,21.4779C409.27105,320.35787,411.60534,327.90375,413.51771,333.02513Z",
    transform: "translate(-210.43251 -174.87964)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M533.87254,501.6117c.03629.00039.07232-.00038.10861-.0023a72.88485,72.88485,0,0,0,1.63072-145.467,1.66268,1.66268,0,0,0-1.2584.43618,1.64558,1.64558,0,0,0-.53753,1.2048l-1.59355,142.145a1.66856,1.66856,0,0,0,1.65015,1.68331Z",
    transform: "translate(-210.43251 -174.87964)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M476.71192,379.64723a2.14626,2.14626,0,0,1,1.50641.64339L527.153,430.33479a2.12319,2.12319,0,0,1,.60908,1.51791l-.76254,68.017a2.11556,2.11556,0,0,1-.69123,1.54877,2.1478,2.1478,0,0,1-1.6145.56065,73.3615,73.3615,0,0,1-49.61222-121.606,2.14873,2.14873,0,0,1,1.551-.72551C476.6589,379.647,476.68547,379.64691,476.71192,379.64723Z",
    transform: "translate(-210.43251 -174.87964)",
    fill: "#e6e6e6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M526.47146,355.56136a2.15453,2.15453,0,0,1,1.46424.59838,2.11709,2.11709,0,0,1,.65725,1.56556l-.68791,61.36918a2.13689,2.13689,0,0,1-3.66432,1.47006L481.5392,376.89477a2.14134,2.14134,0,0,1,.03578-3.02811q.03872-.03771.07922-.0735A73.51556,73.51556,0,0,1,526.33883,355.564C526.38292,355.56174,526.42738,355.56094,526.47146,355.56136Z",
    transform: "translate(-210.43251 -174.87964)",
    fill: "#00bfa6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M460.06053,427.365a9.97532,9.97532,0,0,0-7.666,3.58362l-44.80957-1.40076-1.7539-7.55432-23.18946,11.31628,3,20.68915,68.29029-8.7439a9.99612,9.99612,0,1,0,6.12866-17.89007Z",
    transform: "translate(-210.43251 -174.87964)",
    fill: "#9f616a"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M378.86351,441.83085,377.6179,380.198a16.32125,16.32125,0,1,1,32.63916-.33008v45.043Z",
    transform: "translate(-210.43251 -174.87964)",
    fill: "#cbcbcb"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M592.43251,724.87964h-381a1,1,0,1,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-210.43251 -174.87964)",
    fill: "#cbcbcb"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.2fdf3ae82858cfdabc1185ef6f4db70c.svg";
export { ForwardRef as ReactComponent };